// extracted by mini-css-extract-plugin
module.exports = {"metrics_pm":"MemorandumValues_metrics_pm__3Jho_","column_metrics":"MemorandumValues_column_metrics__gedot"};